export default __webpack_public_path__ + "static/media/wave2.4e4b1bcc.png";